import Navbar from '@/components/Navbar'
import HeroSection from '@/components/HeroSection'
import FeaturesSection from '@/components/FeaturesSection'
import UseCasesSection from '@/components/UseCasesSection'
import PricingSection from '@/components/PricingSection'
import FAQSection from '@/components/FAQSection'
import BlogChangelogTeaser from '@/components/BlogChangelogTeaser'
import DownloadSection from '@/components/DownloadSection'
import Footer from '@/components/Footer'

export default function LandingPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <div id="features"><FeaturesSection /></div>
      <div id="use-cases"><UseCasesSection /></div>
      <div id="pricing"><PricingSection /></div>

      <div id="faq"><FAQSection /></div>
      <div id="changelog"><BlogChangelogTeaser /></div>
      <div id="download"><DownloadSection /></div>
      <Footer />
    </div>
  )
}